import React, { useEffect } from "react"
import { connect } from "react-redux"
import { Box } from "@infotech/uikit-grid"
import Select from "@infotech/uikit-select"
import { CircleIcon } from "@infotech/uikit-extra-icons"
import "react-select/dist/react-select.css"
import get from "lodash/get"
import isEmpty from "lodash/isEmpty"
import {
  requestTransitionList,
  updateCalendarEventStatus,
  updateStatus,
} from "src/engine/modules/status/actions/creators"
import { hasPermission } from "src/engine/modules/currentUser"
import { selectStatus } from "src/engine/modules/status/selectors"
import { EVENTS_CHANGE_STATUS } from "src/constants/knownPermissions"

const StatusSelect = ({
  status,
  eventData,
  eventUuid,
  disabled,
  type,
  statusModel: {
    transitions,
    status: { pending },
  },
  readTransitionList,
  updateCalendarEventStatus,
  updateStatus,
  disableByPermission,
}) => {
  const disableSelect = isEmpty(transitions) || pending || disabled
  useEffect(() => {
    if (eventUuid) {
      readTransitionList({ event: eventUuid })
    }
  }, [eventUuid, status])
  const statusOptions = status ? [status].concat(transitions) : transitions

  const options = statusOptions.map(item => ({
    value: item.id,
    code: item.code,
    label: item.name,
    color: item.color,
    icon: CircleIcon,
    item,
  }))
  return (
    <Box>
      <Select
        hideSelectedOptions
        disabled={disableSelect || disableByPermission}
        isLoading={pending}
        placeholder="Статус события"
        options={options}
        value={get(status, `id`)}
        onChange={({
          target: {
            value: { code, item },
          },
        }) => {
          if (type === `eventCalendar`) {
            updateCalendarEventStatus({
              event: eventUuid,
              newStatusCode: code,
            })
          }
          if (type === `eventForm`) {
            updateStatus({
              data: eventData,
              status: item,
              event: eventUuid,
              newStatusCode: code,
            })
          }
        }}
        styles={{
          option: base => ({
            ...base,
            fontWeight: 600,
          }),
          singleValue: base => ({
            ...base,
            fontWeight: 600,
          }),
        }}
      />
    </Box>
  )
}

export default connect(
  state => ({
    statusModel: selectStatus(state),
    disableByPermission: !hasPermission(EVENTS_CHANGE_STATUS)(state),
  }),
  dispatch => ({
    readTransitionList: (...args) => dispatch(requestTransitionList(...args)),
    updateCalendarEventStatus: (...args) =>
      dispatch(updateCalendarEventStatus(...args)),
    updateStatus: (...args) => dispatch(updateStatus(...args)),
  }),
)(StatusSelect)
